/**
 * Marca no quadradinho do trilho de ícones: o ícone quadrado da empresa ou, sem ele, a inicial do nome sobre a cor da
 * marca. Nunca o logotipo completo, que espremido em 36 px fica ilegível.
 */
export function RailBrandMark({ icon, product }: { icon: string | null; product: string }) {
  return icon ? <img src={icon} alt="" referrerPolicy="no-referrer" /> : <>{(product.trim() || 'Hive').charAt(0).toUpperCase()}</>;
}
